<app-navbar [class.visible]="nav.showNavbar"></app-navbar>

<router-outlet></router-outlet>

<p-toast
  [showTransformOptions]="'translateY(-100%)'"
  [showTransitionOptions]="'150ms'"
  [hideTransformOptions]="'translateX(50%)'"
  [hideTransitionOptions]="'150ms'"
  [class.snaptop]="!nav.showNavbar"
  [breakpoints]="{
    '576px': {
      width: '92vw',
    },
  }"
  position="top-center"
/>

<p-confirmDialog appendTo="body" />

<p class="project-text">Progetto 17184 – MOTION -  SPOKE 4 - Smart mobility, housing and energy solutions - Tema 2</p>
